module.exports = __webpack_public_path__ + "img/6.85f58c97.jpg";